<template>
  <el-dropdown-menu class="login-user-dropdown-menu">
    <el-dropdown-item
      v-for="(item, i) in sideList"
      :key="i"
      :icon="item.icon"
      @click.native="action(item)"
      ><span class="dropdown-item-content">{{ item.content }}</span></el-dropdown-item
    >
    <PersonalFooter
      :bannerMap="bannerMap"
      @action="action"
      @signout="signout"
    />
  </el-dropdown-menu>
</template>
<script>
import PersonalFooter from './personalFooter.vue'

export default {
  name: 'User',
  components: {
    PersonalFooter
  },
  props: {
    bannerMap: Object,
    sideList: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {}
  },
  methods: {
    action(item) {
      this.$emit('action', item.tag, item)
    },
    signout() {
      this.$emit('signout')
    },
  }
}
</script>
<style lang="scss">
.login-user-dropdown-menu {
  position: fixed !important;
  top: 55.5px !important;
  margin-top: 0 !important;
  padding: 0;
  padding-top: 8px;
  width: 216px;
  border: none;
  .el-dropdown-menu__item {
    position: relative;
    padding: 12px 16px;
    padding-left: 44px;
    line-height: 20px;
    font-family: 'Aspira Medium';
    font-weight: 500;
    font-size: 0;
    color: #000000;

    &:hover,
    &:focus {
      color: #000000 !important;
      background: #f5f5f7 !important;
    }
    i {
      position: absolute;
      left: 16px;
      top: 0;
      bottom: 0;
      margin: auto;
      height: 20px;
      font-size: 20px;
    }
  }
  .popper__arrow {
    display: none;
  }
  .dropdown-item-content {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
  }
}
</style>
